export default (value) => {
  if(value === undefined || value === null || !value)
    return value;

  return value.toString().replace(/\D+/g, '').padStart(8, '0');
}
